import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import './index.scss';
import DocumentList from '../global/DocumentList';
import Container from "../global/Container";
import Context from '../../context';
import Summary from "../Summary";
import { useLocation } from "react-router-dom";
import DocumentViewer from "../global/DocumentViewer";
import NotFoundScreen from "../global/errorPages/NotFoundScreen";
import AddIcon from "@mui/icons-material/Add";
import DocsPermissions from "../MyDocuments/DocsPermissions";
import { getEwaBackPath } from "../../libraries/ewa/helpers";
import { BACK_NAVIGATION_TYPE } from "../../helpers/constants";

const Documents = ({ type }) => {
  const { itin, viewMode, navMenuItems } = useContext(Context);
  const [docScreenName, setDocScreenName] = useState(null);
  const { pathname } = useLocation();
  const urlParts = useMemo(() => pathname.split('/'), [pathname]);
  const finalPart = urlParts[urlParts.length - 1];
  const fileInputRef = useRef(null);

  const closePath = useMemo(() => {
    const ewaBackPath = getEwaBackPath();
    return (ewaBackPath && pathname === ewaBackPath?.entryPath) ? BACK_NAVIGATION_TYPE : undefined;
  }, [pathname]);

  const getFiles = () => fileInputRef.current.click();

  const isNavItem = !!navMenuItems.find(item => item.initialPath === pathname);
  const docFolder = isNavItem
    ? itin.documents?.find(doc => doc.pathName === finalPart)
    : itin.documents?.find(doc => doc.id === parseInt(finalPart) && doc.type === 'folder')

  useEffect(() => {
    if (docFolder) {
      if (isNavItem) {
        const menuItemLabel = itin.menu.find(x => x.segueId === docFolder.id).label;
        setDocScreenName(menuItemLabel);
      } else {
        setDocScreenName(docFolder?.name || null);
      }
    }

    return () => setDocScreenName(null);
  }, [docFolder, isNavItem, itin.menu]);

  const getMobileHeaderButtonRightConfig = () => {
    if (type !== "my-documents") return;
    return {
      className: "upload-new-file",
      onClick: getFiles, // TODO* myDoc add logic
      icon: <AddIcon className="upload-new-file-icon" />
    };
  };

  // TODO* myDoc add appropriate data instead of itin.documents and change docScreenName instead of MY DOCSSS
  // for stays actions
    if (type === 'travel' || type === 'destination') {
    return (
      <Container className="container-documents" mainElementClassName={`documents documents-${viewMode}`}
                 mobileHeaderButtonRight={getMobileHeaderButtonRightConfig()}>
        <DocumentList section={type} data={type !== "my-documents" ? itin[`${type}Documents`] : itin.documents}/>
      </Container>
    )
  }

  if (type === "my-documents") {
    // TODO* myDoc it might make sense to move this logic into a separate component

    if (urlParts.includes('view')) {
        const docData = itin.documents.find(doc => doc.id === parseInt(finalPart));
        return docData ? <DocumentViewer docData={docData} /> : <NotFoundScreen isDocument />
    }

    // TODO* myDoc it might make sense to pass data in DocsPermissions instead of docId
    if (urlParts.includes('docs-permissions')) {
      return <DocsPermissions docId={finalPart} />
    }


    const folderData = docFolder?.entries.map(id => itin.documents.find(doc => doc.id === id));
    return (
      <Container className="container-documents" mainElementClassName={`documents documents-${viewMode}`}
                 docScreenName={docFolder?.name ? docFolder.name.charAt(0).toUpperCase() + docFolder.name.slice(1) : 'MY DOCSSS'}
                 mobileHeaderButtonRight={getMobileHeaderButtonRightConfig()}>
        <DocumentList section={type} data={folderData ?? itin.documents} fileInputRef={fileInputRef} getFiles={getFiles}/>
      </Container>
    )
  }



  if (!docFolder) {
    const docData = itin.documents.find(doc => doc.id === parseInt(finalPart));
    return docData ? <DocumentViewer docData={docData} /> : <NotFoundScreen isDocument />
  }

  const data = docFolder.entries.map(id => itin.documents.find(doc => doc.id === id));

    return (
      <Container className="container-documents" mainElementClassName={`documents documents-${viewMode}`} docScreenName={docScreenName} closePath={closePath}>
        {docFolder?.displayMode === 'gallery'
          ? <Summary type="gallery" isDocuments data={data} showTitle={!isNavItem} docScreenName={docScreenName} />
          : <DocumentList section={type} data={data} showTitle={!isNavItem} docScreenName={docScreenName} />
        }
      </Container>
    )
};

export default Documents;
